import React, {FC} from "react"
import styled, {css} from "styled-components"

import authentication from "@irati/auth"
import Spacing from "@irati/ui/src/Spacing"
import MySavingsCard from "@irati-web/my-savings/src/components/SavingsTracker/Widgets/MySavings"
import MySavingsCalculator from "@irati-web/my-savings/src/components/MySavingsCalculator"

import ExpiryInformationBanner from "./ExpiryInformationBanner"
import AdsCarousel from "./AdsCarousel"
import Wallet from "./Wallet"
import Lanes from "./Lanes"

interface Props {
  showOverlay: boolean
}

const Content: FC<Props> = ({showOverlay}) => {
  const showLanes = !authentication.apps("platform.homepageLanesHidden")

  return (
    <Spacing paddingBottom={5} style={{position: "relative"}}>
      <ExpiryInformationBanner />
      <MySavingsCard />
      {showLanes && (
        <>
          <Wallet />
          <MySavingsCalculator />
          <AdsCarousel />
          <Lanes />
          <Overlay isActive={showOverlay} />
        </>
      )}
    </Spacing>
  )
}

interface OverlayProps {
  isActive?: boolean
}

const Overlay = styled.div<OverlayProps>`
  ${({theme, isActive}) => css`
    ${!isActive && "display: none;"}
    background-color: ${theme.colors.greys.dark};
    opacity: 0.6;
    width: 100vw;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    z-index: 99;
  `}
`

export default Content
